import React from 'react';
import { HeaderDialog } from 'styles/Styles.styled';
import DialogClearStyles from './DialogClearStyles';
import ChangeEmailDialogForm from './ChangeEmailDialogForm';

interface Props {
  visible: boolean;
  onHide(): void;
}

const ChangeEmailDialog: React.FC<Props> = ({ visible, onHide }) => {
  return (
    <DialogClearStyles
      visible={visible}
      onHide={onHide}
      header={<HeaderDialog>Change email address</HeaderDialog>}
      closable={false}
      draggable={false}
    >
      <ChangeEmailDialogForm onHide={onHide} />
    </DialogClearStyles>
  );
};

export default ChangeEmailDialog;